// extracted by mini-css-extract-plugin
export default {"container":"field-error-message_container__j0fhI","text":"field-error-message_text__PNV4-"};